import React, { useContext, useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  Typography,
  Sheet,
} from "@mui/joy";
import toast from "react-hot-toast";
import axiosInstance from "../../api/axios";
import AuthContext from "../../contexts/authContext";

export default function AddScheme({ openScheme, setOpenScheme }) {
  const [schemeName, setSchemeName] = useState("");
  const { setRefresh } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!schemeName || schemeName.trim() === "") {
      toast.error("All fields are required.");
      return;
    }

    try {
      const res = await axiosInstance.post("/schemes/add", {
        schemeName,
      });

      if (res.status === 200) {
        toast.success("Scheme added successfully!");
        setSchemeName("");
        setOpenScheme(false);
        setRefresh(true);
      }
    } catch (err) {
      toast.error("An error occurred while adding the scheme.");
    }
  };

  return (
    <Modal
      open={openScheme}
      onClose={() => setOpenScheme(false)}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 300,
          width: "100%",
          bgcolor: "#FEDDDD",
          p: 4,
          borderRadius: "md",
          boxShadow: "lg",
        }}
      >
        <ModalClose
          sx={{
            m: 1,
            "& svg": { color: "#800001" },
            "&:hover": {
              backgroundColor: "#800001",
              "& svg": { color: "#fff" },
            },
          }}
          onClick={() => setOpenScheme(false)}
        />

        <Typography
          level="h4"
          sx={{
            color: "#800001",
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          Add Scheme
        </Typography>

        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Scheme Name</FormLabel>
            <Input
              name="schemeName"
              value={schemeName}
              type="text"
              onChange={(e) => setSchemeName(e.target.value)}
              required
            />
          </FormControl>

          <Button
            type="submit"
            fullWidth
            variant="solid"
            sx={{
              mt: 3,
              backgroundColor: "#800001",
              color: "white",
              "&:hover": {
                backgroundColor: "#800001",
                color: "#fff",
              },
            }}
          >
            Submit
          </Button>
        </form>
      </Sheet>
    </Modal>
  );
}
